import Vue from 'vue';
import Vuex from 'vuex';
import http from '/src/api/index';
Vue.use(Vuex);


function getRole(router,role){
	return router.filter(v=>{
		var some = role.some(e=>v.meta.code==e.Code)
		if(some){
			if(v.children && v.children.length!=0){
				v.children = getRole(v.children,role)
			}
			return v
		}else{
			if(v.children){
				v.children = getRole(v.children,role)
				if(v.children.length!=0){
					return v
				}else{
					return false
				}
			}else{
				return false
			}
		}
	})
}

const store = new Vuex.Store({
  state: {
    addrouter:[1],
	menu:[]
  },
  mutations: {
	  setMenu(state,data){
		  state.menu = data;
	  }
  },
  actions:{
	  setMenu({commit},data){
		  return new Promise((res,req)=>{
			  var user = JSON.parse(localStorage.getItem('UserData'))
			  http.getEmplooyeeRole(user.JobNumber).then(v=>{
				  var arr =  getRole(data[0].children,v.data);
				  data[0].children = arr
				  if(arr.length==0){
					  req({ error:"权限错误",code:200 })
				  }else{

					  commit('setMenu',arr)
					  res(data)
				  }
			  })
		  })
	  }
  },
  getters:{}
})


export default store;